import React from 'react'

export default ({ color = '#AAA7B0', width = '24', height = '24', className }) => (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M12 3a9 9 0 110 18 9 9 0 010-18zM8.705 7.292a.999.999 0 10-1.413 1.413L10.588 12l-3.296 3.295a.999.999 0 101.413 1.413L12 13.412l3.295 3.296a.999.999 0 001.413-1.413L13.412 12l3.296-3.295a.999.999 0 00-1.413-1.413L12 10.588z" fill={color} fillRule="evenodd"/>
    </svg>
)
